import { render, staticRenderFns } from "./NavigationDesktop.vue?vue&type=template&id=97cf9216&scoped=true"
import script from "./NavigationDesktop.vue?vue&type=script&lang=ts"
export * from "./NavigationDesktop.vue?vue&type=script&lang=ts"
import style0 from "./NavigationDesktop.vue?vue&type=style&index=0&id=97cf9216&prod&lang=scss"
import style1 from "./NavigationDesktop.vue?vue&type=style&index=1&id=97cf9216&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97cf9216",
  null
  
)

export default component.exports